import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import axiosInstance from "../../API/Axios/AxiosConfig";
import {googleLogout} from "@react-oauth/google";
import URLS from "../../API/Axios/URLS";
import {toast} from "react-toastify";

const initialState = {
    comments: [],
    count: 0,
    next: null,
    previous: null,
    pageNumber: 1,
    sortBy: "newest",
    isFirstLoad: true,
}

export const COMMUNITY_COMMENT_ACTIONS = {
    ADD_OLD_COMMENTS: "ADD_OLD_COMMENTS",
    ADD_NEW_COMMENT: "ADD_NEW_COMMENT",
    UPDATE: "UPDATE",
}


const CommunityReducer = (state = initialState, action) => {
    switch (action.type) {
        case COMMUNITY_COMMENT_ACTIONS.ADD_OLD_COMMENTS:
            return {
                ...state,
                comments: [...state.comments, ...action.payload],
            }
        case COMMUNITY_COMMENT_ACTIONS.ADD_NEW_COMMENT:
            return {
                ...state,
                comments: [action.payload, ...state.comments],
                count: state.count + 1,
            }
        case COMMUNITY_COMMENT_ACTIONS.UPDATE:
            return {
                ...state,
                ...action.payload,
            }

        default:
            return state;
    }
}


export function useCommunity() {
    const dispatch = useDispatch();
    const state = useSelector(state => state.CommunityReducer);
    const [isLoading, setIsLoading] = useState(false);

    function getCommunityComments(pageNumber = 1, sortBy = "newest") {
        if (isLoading) return;

        setIsLoading(true)
        axiosInstance.get(URLS.getCommunityComments, {
            params: {
                page: pageNumber,
                sortBy: sortBy,
            }
        }).then((res) => {
            dispatch({
                type: COMMUNITY_COMMENT_ACTIONS.UPDATE,
                payload: {
                    count: res.data.count,
                    comments: pageNumber === 1 ? [...res.data.results] : [...state.comments, ...res.data.results],
                    next: res.data.next,
                    previous: res.data.previous,
                    pageNumber: pageNumber,
                },
            })

        }).catch((err) => {
            // status == 404
            if (err.response?.status === 404) {
                dispatch({
                    type: COMMUNITY_COMMENT_ACTIONS.UPDATE,
                    payload: {

                        next: null,
                        previous: null,

                    },
                })
            }
            console.log(err)
        }).finally(() => {
            setIsLoading(false)
        })
    }


    function addNewComment(comment) {
        toast.promise(axiosInstance.post(URLS.addCommunityComment, comment).then((res) => {
                dispatch({
                    type: COMMUNITY_COMMENT_ACTIONS.ADD_NEW_COMMENT,
                    payload: res.data?.data,
                })
            }),
            {
                pending: "Posting comment...",
                success: "Comment posted successfully.",
                error: "Comment failed to post.",
            },{
            hideProgressBar:false,
            });
    }


    function loadMoreComments() {
        if (isLoading || !state?.next) return;
        getCommunityComments(state.pageNumber + 1, state.sortBy)
    }

    function SortBy(sortBy) {
        dispatch({
            type: COMMUNITY_COMMENT_ACTIONS.UPDATE,
            payload: {
                comments: [],
                sortBy: sortBy,

            },
        })
        getCommunityComments(1, sortBy)
    }

    const initalLoad = () => {
        if (!state.isFirstLoad) return;
        getCommunityComments()
        dispatch({
            type: COMMUNITY_COMMENT_ACTIONS.UPDATE,
            payload: {
                isFirstLoad: false,
            },
        })
    }

    function removeComment(id){
        let cahcedComments = [...state.comments];
        let index = cahcedComments.findIndex((comment) => comment.id === id);
        if (index !== -1) {
            cahcedComments.splice(index, 1);
            dispatch({
                type: COMMUNITY_COMMENT_ACTIONS.UPDATE,
                payload: {
                    comments: cahcedComments,
                    count: state.count - 1,
                },
            })
        }
    }
    function deleteComment(id){
        toast.promise(axiosInstance.delete(URLS.DeleteAComment, {
            data: {
                commentId: id,
            }
        }).then((res) => {
            removeComment(id);

        }),{
            pending: "Deleting comment...",
            success: "Comment deleted successfully.",
            error: "Comment failed to delete.",
        },{
            hideProgressBar:false,
        })
    }

    const actions = {
        getCommunityComments: getCommunityComments,
        loadMoreComments: loadMoreComments,
        SortBy: SortBy,
        addNewComment: addNewComment,
        initalLoad: initalLoad,
        deleteComment: deleteComment,

    }

    return {state, isLoading, actions};
}


export default CommunityReducer;